
import React from "react";
import AGBContent from "@/components/AGB";
import { Helmet } from "react-helmet";

const AGBPage = () => {
  return (
    <div className="min-h-screen bg-joerg-50">
      <Helmet>
        <title>Allgemeine Geschäftsbedingungen | Jörg Hörmann Coaching & Consulting</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen für Coaching-Dienstleistungen von Jörg Hörmann. Informieren Sie sich über unsere Vertragsbestimmungen für Privatpersonen." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="pt-32">
        <AGBContent />
      </div>
    </div>
  );
};

export default AGBPage;
